import React from "react";
import { v4 as uuidv4 } from "uuid";
import { useLazyQuery } from "@apollo/client";
import debounce from "lodash/debounce";
import { GET_USER } from "../../GraphQL";
import { Search } from "semantic-ui-react";

const UserSearch = ({ onSelect, initialUser }) => {
  const [getUser, { loading, data }] = useLazyQuery(GET_USER);
  const debouncedGetUser = debounce((_e, { value }) => {
    getUser({
      variables: { id: value },
      fetchPolicy: "network-only",
    });
  }, 1000);

  const props = {};
  if (initialUser) {
    props.defaultValue = initialUser.name;
  }

  return (
    <Search
      loading={loading}
      icon="add"
      placeholder={uuidv4()}
      onSearchChange={debouncedGetUser}
      onResultSelect={() => onSelect(data.user)}
      results={
        data && data.user
          ? [
              {
                title: data.user.name,
                id: data.user.sub,
              },
            ]
          : []
      }
      {...props}
    />
  );
};

export default UserSearch;
